import { RSAA } from 'redux-api-middleware';
import { get } from 'lodash';
import endpoints from '../../utils/endpoints';
import { getExchangeRateRequest, getExchangeRateIFTRequest } from '../../helpers/ratesApiRequestBuilder';
import { getAccountByAccountNoAndSortCode } from '../accounts/selectors';
import { TYPE_IFT } from '../../config';

export const SUBMIT_GET_EXCHANGE_RATES_REQUEST = 'SUBMIT_GET_EXCHANGE_RATES_REQUEST';
export const SUBMIT_GET_EXCHANGE_RATES_SUCCESS = 'SUBMIT_GET_EXCHANGE_RATES_SUCCESS';
export const SUBMIT_GET_EXCHANGE_RATES_FAILURE = 'SUBMIT_GET_EXCHANGE_RATES_FAILURE';
export const RESET_FX_RATES = 'RESET_FX_RATES';

export const fetchRatesRequest = (body, paymentId, accountId) => ({
	[RSAA]: {
		endpoint: endpoints.getExchangeRate.resolve(null, null, accountId),
		method: 'POST',
		types: [
			SUBMIT_GET_EXCHANGE_RATES_REQUEST,
			{
				type: SUBMIT_GET_EXCHANGE_RATES_SUCCESS,
				meta: { paymentId },
			},
			SUBMIT_GET_EXCHANGE_RATES_FAILURE,
		],
		headers: { 'x-bpi-version': endpoints.getExchangeRate.x_bpi_version },
		body,
	},
});

export const fetchRates = (payment, type) => (dispatch, getState) => {
	const state = getState();
	const body = type === TYPE_IFT ? getExchangeRateIFTRequest(payment) : getExchangeRateRequest(payment);
	const {
		from_account: { account_uuid, account_number, sort_code },
		id,
	} = payment;
	const accountId = get(
		getAccountByAccountNoAndSortCode(state, {
			accountNumber: account_number,
			sortCode: sort_code,
		}),
		'account_uuid',
		account_uuid
	);
	return dispatch(fetchRatesRequest(body, id, accountId));
};

export const resetFxRates = () => ({ type: RESET_FX_RATES });
